"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionColumn = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const index_js_1 = require("../../Checkbox/index.js");
const index_js_2 = require("../../utils/index.js");
const index_js_3 = require("../../DropdownMenu/index.js");
const index_js_4 = require("../../Buttons/IconButton/index.js");
const index_js_5 = require("../../Menu/index.js");
const Table_js_1 = require("../Table.js");
const selectionColumn_js_1 = require("./selectionColumn.js");
const expanderColumn_js_1 = require("./expanderColumn.js");
const classnames_1 = __importDefault(require("classnames"));
const ACTION_CELL_ID = 'iui-table-action';
/**
 * Action column that adds column manager to the Table header.
 * It is recommended to add this column to the end of the Table
 * and to override its `Cell` prop with your row actions menu.
 * @example
 * {
 *   ...ActionColumn({ columnManager: true }),
 *   Cell: () => (
 *     <DropdownMenu menuItems={menuItems}>
 *       <IconButton
 *         styleType='borderless'
 *         onClick={(e) => e.stopPropagation()}
 *       >
 *         <SvgMore />
 *       </IconButton>
 *     </DropdownMenu>
 *   ),
 * },
 */
const ActionColumn = ({ columnManager = false, } = {}) => {
    return {
        id: ACTION_CELL_ID,
        disableResizing: true,
        disableGroupBy: true,
        minWidth: 48,
        width: 48,
        maxWidth: 48,
        columnClassName: 'iui-slot',
        cellClassName: 'iui-slot',
        disableReordering: true,
        Header: ({ allColumns, dispatch, state }) => {
            const [isOpen, setIsOpen] = React.useState(false);
            const buttonRef = React.useRef(null);
            if (!columnManager) {
                return null;
            }
            const defaultColumnIds = [
                selectionColumn_js_1.SELECTION_CELL_ID,
                expanderColumn_js_1.EXPANDER_CELL_ID,
                ACTION_CELL_ID,
            ];
            const headerCheckBoxes = () => allColumns
                //Filters out any default columns made such as selection and expansion
                .filter(({ id }) => !defaultColumnIds.includes(id))
                .map((column) => {
                const { checked } = column.getToggleHiddenProps();
                const onClick = () => {
                    column.toggleHidden(checked);
                    // If no column was resized then leave table resize handling to the flexbox
                    if (Object.keys(state.columnResizing.columnWidths).length === 0) {
                        return;
                    }
                    // Triggers an update to resize the widths of all visible columns
                    dispatch({ type: Table_js_1.tableResizeStartAction });
                    // If some columns were resized and some columns visibility was enabled, then horizontal scrollbar appears
                    // and table is scrolled to the very left which means our visibility dropdown menu is not visible.
                    // So for better UX we need to scroll to that dropdown menu.
                    queueMicrotask(() => {
                        var _a;
                        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                    });
                };
                return (React.createElement(index_js_5.MenuItem, { key: column.id, icon: React.createElement(index_js_1.Checkbox, { checked: checked, disabled: column.disableToggleVisibility, onClick: (e) => e.stopPropagation(), onChange: onClick, "aria-labelledby": `iui-column-${column.id}` }), onClick: onClick, disabled: column.disableToggleVisibility },
                    React.createElement("div", { id: `iui-column-${column.id}` }, column.render('Header'))));
            });
            const dropdownMenuProps = typeof columnManager !== 'boolean'
                ? columnManager.dropdownMenuProps
                : {};
            return (React.createElement(index_js_3.DropdownMenu, { ...dropdownMenuProps, menuItems: headerCheckBoxes, onHide: (i) => {
                    var _a;
                    setIsOpen(false);
                    (_a = dropdownMenuProps.onHide) === null || _a === void 0 ? void 0 : _a.call(dropdownMenuProps, i);
                }, onShow: (i) => {
                    var _a;
                    setIsOpen(true);
                    (_a = dropdownMenuProps.onShow) === null || _a === void 0 ? void 0 : _a.call(dropdownMenuProps, i);
                }, className: (0, classnames_1.default)('iui-scroll', dropdownMenuProps.className) },
                React.createElement(index_js_4.IconButton, { styleType: 'borderless', isActive: isOpen, ref: buttonRef },
                    React.createElement(index_js_2.SvgColumnManager, null))));
        },
    };
};
exports.ActionColumn = ActionColumn;
